/* jshint node:true */
'use strict';

var React = require('react');

var StatsTable = React.createClass({
    render: function(){
        
        var rows = [];
        var stats = this.props.stats || [];
        
        stats.map(function(stat, i){
            rows.push(
                <tr key={i}>
                    <td className="score" colSpan="2">{stat.home}</td>
                    <td className="label" colSpan="2">{stat.displayName}</td>
                    <td className="score" colSpan="2">{stat.away}</td>
                </tr>
            );
        });
        
        return (
            <table className="compareTable">
                <tbody>
                    {rows.length ? rows : null}
                </tbody>
            </table> 
        );
    }
});

module.exports = StatsTable;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/StatsTable.jsx
 **/